import { FC } from "react";
import { RefObject } from "react";
import { IButton } from "../modalWindows/BaseModalWindow";
import { BaseDocumentForm, IObjectActionProps } from "./baseDocumentForm";

export interface IPrintButton {
    onClick: () => void
    onSubItemClick: () => void
}

interface IBaseDocumentCreatorProps {
    ok?: IButton,
    save?: IButton,
    cancel?: IButton
    print?: IPrintButton
    otherAction?: IButton
    checkKiz?: IButton
    otherMenuActions?: IButton[]
    valid?: boolean
    documentFormClassName?: string
    tabIndex?: number
    'data-field-id'?: string
    // Ref для target tour на кнопки подтверждения документа.
    actionButtonsRef?: RefObject<HTMLDivElement>
}

const BaseDocumentCreator: FC<IBaseDocumentCreatorProps> = (props) => {
    return (
        <BaseDocumentForm
            documentFormClassName={props.documentFormClassName}
            actionButtonsRef={props.actionButtonsRef}
            checkKiz={props.checkKiz && { onClick: () => props.checkKiz?.onClick(), title: props.checkKiz?.title ?? 'Проверить КИЗ', disabled: props.checkKiz?.disabled, sendRequestSpinner: props.checkKiz?.sendRequestSpinner }}
            save={props.save && { onClick: () => props.save?.onClick(), title: props.save?.title ?? 'Сохранить', disabled: props.save?.disabled, sendRequestSpinner: props.save?.sendRequestSpinner, sendRequestGlobal: props.save?.sendRequestGlobal, tabIndex: props.save?.tabIndex, 'data-field-id': props.save?.["data-field-id"] }}
            ok={props.ok && { onClick: () => props.ok?.onClick(), title: props.ok?.title ?? 'ОК', disabled: props.ok?.disabled, sendRequestSpinner: props.ok?.sendRequestSpinner, sendRequestGlobal: props.save?.sendRequestGlobal, tabIndex: props.ok?.tabIndex, 'data-field-id': props.ok?.["data-field-id"] }}
            cancel={props.cancel && { onClick: () => props.cancel?.onClick(), title: props.cancel?.title ?? 'Отмена', tabIndex: props.cancel?.tabIndex, 'data-field-id': props.cancel?.["data-field-id"]  }}
            print={props.print && {
                onClick: () => props.print?.onClick(),
                onSubItemClick: () => props.print?.onSubItemClick(),
                title: 'Печать'
            }}
            otherAction={props.otherAction && { onClick: () => props.otherAction?.onClick(), title: props.otherAction?.title ?? 'Действия', disabled: props.otherAction?.disabled }}
            otherMenuActions={props.otherMenuActions?.map((item) => {
                return {title: item.title, onClick: item.onClick, disabled: item.disabled} as IObjectActionProps
            })}
        >
            {props.children}
        </BaseDocumentForm>
    )
}

export default BaseDocumentCreator
